import * as React from 'react';

import useHeartbeat from './useHeartbeat';

const ActiveLogic = () => {
  useHeartbeat();

  return null;
};

const WithHeartbeat = () => <ActiveLogic />;

export default WithHeartbeat;
